export default "__VITE_ASSET__wN6oVJly__"